module.exports = __webpack_public_path__ + "img/2f_r_kokoro@2x.50e5aa60.png";